export default "/_next/static/images/27cdeec65c0902e044f6f9701606768f.png";